export const UserAvatarService = Symbol('UserAvatarService');
